import { Card, CardBody, CardHeader, Collapse } from "reactstrap";
import { useAppDispatch, useAppSelector } from "../../../../../../ReduxToolkit/Hooks";
import { setAccount } from "../../../../../../ReduxToolkit/Reducers/Messenger/MainSidebar";
import { Href, RequestAccount } from "../../../../../../Constants/Constants";

const RequestAccountInfo = () => {
    const { account } = useAppSelector((state) => state.mainSidebar);
    const dispatch = useAppDispatch();
  return (
    <Card>
      <CardHeader onClick={() => dispatch(setAccount(account !== "5" ? "5" : ""))}>
        <a href={Href}>
          {RequestAccount}
          <i className={`fa fa-angle-${account === "5" ? "up" : "down"}`} />
        </a>
      </CardHeader>
      <Collapse className={`${account === "5" ? "show" : ""}`}>
        <CardBody>
          <a className="p-0 req-info" href={Href}>Request Info</a>
          <p><b>Note : </b>Create a report of your account information and settings, which you can access ot port to another app.</p>
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default RequestAccountInfo;
